enum Environment {
    LOCAL = 'LOCAL',
    DEV = 'DEV',
    STAGE = 'STAGE',
    MT1 = 'MT1',
    PROD = 'PROD'
}

export { Environment };
